export default __webpack_public_path__ + "static/media/sponsor-bg-m-2-cn.ba90694c.webp";